import { LinearProgress, Stack, Typography } from '@mui/material';

export type TierColor = 'error' | 'warning' | 'info' | 'primary';

export interface TierBarProps {
  readonly tier: string;
  readonly count: number;
  readonly total: number;
  readonly description: string;
  readonly color: TierColor;
  readonly accent?: boolean;
}

/**
 * Tier distribution row: label + description + count above a thin progress
 * bar. Mirrors the VSO tier list.
 */
export function TierBar({ tier, count, total, description, color, accent = false }: TierBarProps) {
  const pct = total > 0 ? (count / total) * 100 : 0;

  return (
    <Stack spacing={0.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="baseline" spacing={1}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              color: (theme) => (accent ? theme.palette.error.main : theme.palette.text.primary),
            }}
          >
            {tier}
          </Typography>
          <Typography variant="caption" sx={{ color: (theme) => theme.palette.text.secondary }}>
            {description}
          </Typography>
        </Stack>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 700,
            color: (theme) => (accent ? theme.palette.error.main : theme.palette.text.primary),
          }}
        >
          {count}
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={pct}
        color={color}
        sx={{
          height: 8,
          borderRadius: (theme) => `${theme.shape.borderRadius}px`,
          bgcolor: (theme) => theme.palette.action.hover,
        }}
      />
    </Stack>
  );
}
